import { useParams } from 'react-router-dom';
import { getActiveSubscribeCampaign } from '../../config/campaigns';
import NotFoundPage from '../shared/NotFoundPage';
import RowLayoutTemplate from './templates/RowLayoutTemplate';
import OldLayoutTemplate from './templates/OldLayoutTemplate';

export default function SubscribePage() {
  const { slug = '' } = useParams<{ slug: string }>();
  const config = getActiveSubscribeCampaign(slug);

  if (!config) {
    return <NotFoundPage />;
  }

  switch (config.template) {
    case 'form-old-layout':
      return <OldLayoutTemplate config={config} />;
    default:
      return <RowLayoutTemplate config={config} />;
  }
}
